import React, { useState, useEffect } from 'react';
import { makeStyles, ThemeProvider as CoreThemeProvider, createMuiTheme as createCoreTheme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import Chip from '@mui/material/Chip';

import { useHistory } from "react-router-dom";
import moment from 'moment';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';

import Checkbox from '@material-ui/core/Checkbox';
import { useTheme, ThemeProvider as MuiThemeProvider, createTheme as createMuiTheme } from "@mui/material/styles";
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';

import api from '../../../../../../services/api';
import MenuRecursosAdministrativos from '../components/menu';
import NavegadorGestao from "../../../../../../components/NavBarGestao";
import { useLocation } from 'react-router-dom';


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));



export default function CadastroSaidaEstoque() {

    const [loading, setLoading] = useState(true);
    const [tipo, setTipo] = useState(0);

    const checkDarkMode = () => {
        const dMode = Cookies.get('darkMode');
        const dTema = Cookies.get('tema');
        if (dMode !== undefined) {
            return dMode === 'true';
        } else if (dTema !== undefined) {
            return dTema === 'dark';
        }
        return false;
    };

    const [darkMode, setDarkMode] = useState(checkDarkMode());

    useEffect(() => {
        const interval = setInterval(() => {
            const isDark = checkDarkMode();
            if (isDark !== darkMode) {
                setDarkMode(isDark);
            }
        }, 1000);

        const handleFocus = () => {
            setDarkMode(checkDarkMode());
        };

        window.addEventListener('focus', handleFocus);
        return () => {
            clearInterval(interval);
            window.removeEventListener('focus', handleFocus);
        };
    }, [darkMode]);

    const themeHelper = React.useMemo(() => ({
        bg: darkMode ? '#121212' : '#ffffff',
        paper: darkMode ? '#1e1e1e' : '#ffffff',
        text: darkMode ? '#ffffff' : '#000000',
        textSecondary: darkMode ? '#aaaaaa' : '#666666',
        border: darkMode ? '#333333' : '#e0e0e0',
        primary: darkMode ? '#bb86fc' : '#1976d2',
        secondary: darkMode ? '#03dac6' : '#dc004e',
    }), [darkMode]);

    // Create MUI v4 and v5 themes
    const coreTheme = React.useMemo(() => createCoreTheme({
        palette: {
            type: darkMode ? 'dark' : 'light',
            primary: { main: themeHelper.primary },
            secondary: { main: themeHelper.secondary },
            background: { default: themeHelper.bg, paper: themeHelper.paper },
            text: { primary: themeHelper.text, secondary: themeHelper.textSecondary },
        },
        overrides: {
            MuiTextField: {
                root: darkMode ? {
                    '& label.Mui-focused': { color: 'white' },
                    '& label': { color: 'white' },
                    '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:after': { borderBottomColor: 'white' },
                    '& .MuiInputBase-input': { color: 'white' },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'white' },
                        '&:hover fieldset': { borderColor: 'white' },
                        '&.Mui-focused fieldset': { borderColor: 'white' },
                    }
                } : {}
            },
            MuiFormLabel: {
                root: darkMode ? { color: 'white', '&$focused': { color: 'white' } } : {}
            },
            MuiInputBase: {
                input: darkMode ? { color: 'white' } : {}
            },
            MuiInputLabel: {
                root: darkMode ? { color: 'white' } : {}
            },
            MuiSelect: {
                icon: darkMode ? { color: 'white' } : {}
            }
        }
    }), [darkMode, themeHelper]);

    const muiTheme = React.useMemo(() => createMuiTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            primary: { main: themeHelper.primary },
            secondary: { main: themeHelper.secondary },
            background: { default: themeHelper.bg, paper: themeHelper.paper },
            text: { primary: themeHelper.text, secondary: themeHelper.textSecondary },
        },
        components: {
            MuiTextField: {
                styleOverrides: {
                    root: darkMode ? {
                        '& label.Mui-focused': { color: 'white' },
                        '& label': { color: 'white' },
                        '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                        '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'white' },
                        '& .MuiInput-underline:after': { borderBottomColor: 'white' },
                        '& .MuiInputBase-input': { color: 'white' },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: 'white' },
                            '&:hover fieldset': { borderColor: 'white' },
                            '&.Mui-focused fieldset': { borderColor: 'white' },
                        }
                    } : {}
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: darkMode ? { color: 'white' } : {}
                }
            },
            MuiSelect: {
                styleOverrides: {
                    icon: darkMode ? { color: 'white' } : {}
                }
            }
        }
    }), [darkMode, themeHelper]);

    const handleChangeTipo = (event) => {
        setTipo(event.target.value);
    };

    const classes = useStyles();
    const history = useHistory();
    const [descricao, setDescricao] = useState('');

    const [ordemServicoSelecionada, setOrdemServicoSelecionada] = useState(null);

    const [todasAsOrdensCompras, setTodasAsOrdensCompras] = useState([]);

    const [ordensServicos, setOrdensServicos] = useState(null);

    const [ordemCompraSelecionada, setOrdemCompraSelecionada] = useState(null);

    const [ordensCompras, setOrdensCompras] = useState(null);

    const [compraSelecionada, setCompraSelecionada] = useState(null);


    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);



    const [solicitantesSelecionados, setSolicitantesSelecionados] = useState([]);

    const [clienteDestinatarioInputValue, setClienteDestinatarioInputValue] = useState('');
    const [clienteDestinatarioSearchResult, setClienteDestinatarioSearchResult] = useState([]);
    const [clienteDestinatario, setClienteDestinatario] = useState(null);

    const [contatoDestinatarioInputValue, setContatoDestinatarioInputValue] = useState('');
    const [contatoDestinatarioSearchResult, setContatoDestinatarioSearchResult] = useState([]);
    const [contatoDestinatario, setContatoDestinatario] = useState(null);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (clienteDestinatarioInputValue && clienteDestinatarioInputValue.length >= 3) {
                const token = Cookies.get('token');
                const headers = { 'Authorization': 'Bearer ' + token };
                api.get(`/v1/protected/clientes/buscarpordescricao/${clienteDestinatarioInputValue}`, { headers })
                    .then(response => {
                        setClienteDestinatarioSearchResult(response.data);
                    })
                    .catch(err => {
                        console.error("Erro ao buscar clientes:", err);
                    });
            } else {
                setClienteDestinatarioSearchResult([]);
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [clienteDestinatarioInputValue]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (contatoDestinatarioInputValue && contatoDestinatarioInputValue.length >= 3) {
                const token = Cookies.get('token');
                const headers = { 'Authorization': 'Bearer ' + token };
                api.get(`/v1/protected/contatos/buscarpornome/${contatoDestinatarioInputValue}`, { headers })
                    .then(response => {
                        setContatoDestinatarioSearchResult(response.data);
                    })
                    .catch(err => {
                        console.error("Erro ao buscar contatos:", err);
                    });
            } else {
                setContatoDestinatarioSearchResult([]);
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [contatoDestinatarioInputValue]);

    function getDescricaoCliente(cliente) {
        if (!cliente) return "";
        let nomeExibicao = "";
        if (cliente.tipocliente === 0) {
            nomeExibicao = `${cliente.nome || ''} ${cliente.sobrenome || ''}`.trim();
        } else {
            nomeExibicao = cliente.nomeempresarial || cliente.razaosocial || cliente.nomefantasia || '';
        }
        return `ID: ${cliente.idcliente} - ${nomeExibicao} - ${cliente.cpf || cliente.cnpj || ''}`;
    }

    const handleAdicionarSolicitante = (event, newValue) => {
        // Verifica se o valor selecionado já está na lista
        const valoresSelecionados = Array.isArray(newValue) ? newValue : [newValue];
        const novosSolicitantes = valoresSelecionados.filter(
            (opcao) => !solicitantesSelecionados.some((selecionado) => selecionado.id_usuario === opcao.id_usuario)
        );

        setSolicitantesSelecionados([...solicitantesSelecionados, ...novosSolicitantes]);
    };


    const handleRemoverSolicitante = (event, solicitanteRemovido) => {
        const novosSolicitantes = solicitantesSelecionados.filter(
            (solicitante) => solicitante.id_usuario !== solicitanteRemovido.id_usuario
        );
        setSolicitantesSelecionados(novosSolicitantes);
    };



    function returnDescricaoSolicitante(usuario) {
        var texto = "ID_Usuario: " + usuario.id_usuario + "\n Nome: " + usuario.nome_amigavel;
        return texto;
    }





    const [solicitantes, setSolicitantes] = useState('');

    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/ordensdeservico/listarordensservicosparacadastro", {
                headers: headers
            }).then(function (response) {
                setOrdensServicos(response.data)

                // console.log(JSON.stringify(response.data));

                api.get("v1/protected/ordensdecompra/listarordenscomprasparacadastro", {
                    headers: headers
                }).then(function (response2) {
                    setOrdensCompras(response2.data)
                    setTodasAsOrdensCompras(response2.data);

                    api.get("/v1/protected/user/listartodos", {
                        headers: headers
                    }).then(function (response3) {
                        setSolicitantes(response3.data)
                        setLoading(false);

                    });


                });

            });




        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar Informações: " + _err)

        }

    }



    useEffect(() => {
        listarInformacoes();


    }, []);


    function returnDescricaoFornecedor(fornecedor) {
        var texto = "Fornecedor_ID: " + fornecedor.id_fornecedor + "\nCPF/CNPJ: " + (fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj) +
            "\nNome/Nome Fantasia: " + (fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) : fornecedor.nome_fantasia);

        return texto;
    }

    function returnDescricaoOrdem(ordem) {

        var texto =
            "ID: " + ordem.id_ordem_servico +
            "\nSolicitação: " + ordem.descricao_solicitacao;

        // ===== Projeto =====
        if (ordem.projeto) {
            texto += "\nProjeto: " + ordem.projeto.descricao_projeto;
        }

        // ===== Proposta =====
        if (ordem.proposta) {
            texto += "\nProposta: " + ordem.proposta.descricao_proposta;
        }

        // ===== Instalação =====
        if (ordem.instalacao) {
            texto += "\nInstalação ID: " + ordem.instalacao.id_instalacao;
        }

        // ===== Ordem de Compra =====
        if (ordem.ordem_compra) {
            texto +=
                "\nOrdem de Compra: " +
                ordem.ordem_compra.id_ordem_compra +
                " - " +
                ordem.ordem_compra.descricao;
        }

        // ===== Usuário Solicitante =====
        if (ordem.usuario_solicitante) {
            texto += "\nSolicitante: " + ordem.usuario_solicitante.nome_amigavel;
        }

        return texto;
    }


    function returnDescricaoExecutor(usuario) {
        var texto = "ID_Usuario: " + usuario.id_usuario + "\n Nome: " + usuario.nome_amigavel;
        return texto;
    }

    function handleSetOrdemCompra(ordem) {
        setOrdemCompraSelecionada(ordem);

        if (!ordem) {
            setSolicitantesSelecionados([]); // limpa os solicitantes se ordem for null
            return;
        }

        if (Array.isArray(ordem.solicitantes) && Array.isArray(solicitantes)) {
            const novosSolicitantes = ordem.solicitantes
                .map(ocs => solicitantes.find(u => u.id_usuario === (ocs.solicitante?.id_usuario)))
                .filter(u => u); // remove undefined se não encontrar no array de solicitantes

            setSolicitantesSelecionados(prev => {
                const todos = [...prev];
                novosSolicitantes.forEach(novo => {
                    if (!todos.some(u => u.id_usuario === novo.id_usuario)) {
                        todos.push(novo);
                    }
                });
                return todos;
            });
        }
    }

    function returnDescricaoOrdemCompra(ordem) {
        if (!ordem) return ""; // protege se ordem for null

        let texto = "Ordem_ID: " + (ordem.id_ordem_compra ?? "") +
            "\nDescrição da Ordem: " + (ordem.descricao ?? "");

        if (Array.isArray(ordem.solicitantes) && ordem.solicitantes.length > 0) {
            texto += "\nSolicitantes: ";
            const nomes = ordem.solicitantes
                .map(ocs => ocs ? ocs.nome_amigavel : null)
                .filter(n => n) // remove nulls
                .join(", ");
            texto += nomes;
        }

        return texto;
    }

    function returnDescricaoCompra(compra) {
        var texto = "Compra_ID: " + compra.id_pre_cotacao + "\nFornecedor: " + compra.nome_fornecedor_amigavel + "\nValor: " + (compra.valor_total + compra.valor_frete);
        return texto;
    }



    async function salvar() {



        if (tipo === 0) {
            alert("Defina o Tipo da Saída de Estoque");
            return;
        }

        if (ordemServicoSelecionada || ordemCompraSelecionada) {

        } else {

            alert("Selecione uma Ordem de Serviço ou Ordem de Compra");
            return;
        }



        try {

            console.log("cadastrar chamado");
            const cadastro = {

                tipo_saida_estoque: tipo,
                descricao: descricao,
                usuario_criador: { id_usuario: Cookies.get("id_usuario") },
                usuario_executor: { id_usuario: Cookies.get("id_usuario") },
                cliente_destinatario: clienteDestinatario ? { id_cliente: clienteDestinatario.idcliente } : null,
                contato_destinatario: contatoDestinatario ? { id_contato: contatoDestinatario.id_contato } : null,
                responsaveis: solicitantesSelecionados.map(u => ({
                    id_usuario: u.id_usuario
                }))

            }

            if (ordemServicoSelecionada) {
                cadastro.id_ordem_servico = ordemServicoSelecionada.id_ordem_servico;
                if (ordemServicoSelecionada.ordem_compra)
                    cadastro.id_ordem_compra = ordemServicoSelecionada.ordem_compra.id_ordem_compra;

            } else {
                cadastro.id_ordem_compra = ordemCompraSelecionada.id_ordem_compra;
            }


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/almoxarifado/saidaestoque/cadastrarsaidaestoque', cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Nova Operação Saída de Estoque Cadastrada")
                history.push({
                    pathname: "/gestao/operacional/almoxarifado/saidaestoque/gerenciarsaidaestoque/" + cadastro_salvo.id_saida_estoque,
                })
            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }

    const handleOrdemServico = (event, ordem) => {
        if (!ordem) {
            setOrdemServicoSelecionada(null);
            setOrdensCompras(todasAsOrdensCompras);
            setSolicitantesSelecionados([]);
            return;
        }

        setOrdemServicoSelecionada(ordem);

        if (
            ordem.usuario_solicitante &&
            ordem.usuario_solicitante.id_usuario &&
            Array.isArray(solicitantes)
        ) {
            const solicitanteEncontrado = solicitantes.find(
                (u) => u.id_usuario === ordem.usuario_solicitante.id_usuario
            );

            if (solicitanteEncontrado) {
                setSolicitantesSelecionados((prev) => {
                    const jaExiste = prev.some(
                        (u) => u.id_usuario === solicitanteEncontrado.id_usuario
                    );

                    if (jaExiste) {
                        return prev;
                    }

                    return [solicitanteEncontrado];
                });
            }
        }
    };

    function handleSetOrdemCompra(ordem) {
        setOrdemCompraSelecionada(ordem);

        if (!ordem) {
            setSolicitantesSelecionados([]); // limpa os solicitantes se ordem for null
            return;
        }

        if (Array.isArray(ordem.solicitantes) && Array.isArray(solicitantes)) {
            const novosSolicitantes = ordem.solicitantes
                .map((ocs) => solicitantes.find((u) => u.id_usuario === ocs.id_usuario))
                .filter((u) => u); // remove undefined se não encontrar no array de solicitantes

            setSolicitantesSelecionados((prev) => {
                const todos = [...prev];

                novosSolicitantes.forEach((novo) => {
                    const jaExiste = todos.some((u) => u.id_usuario === novo.id_usuario);
                    if (!jaExiste) {
                        todos.push(novo);
                    }
                });

                return todos;
            });
        }
    }




    return (
        <CoreThemeProvider theme={coreTheme}>
            <MuiThemeProvider theme={muiTheme}>
                <div style={{ backgroundColor: themeHelper.bg, minHeight: '100vh', color: themeHelper.text }}>

                    <NavegadorGestao
                        Almoxarifado={true}
                        OpSaida={true}
                        corFundo={darkMode ? '#1e1e1e' : 'white'}
                        travado={true}
                        corTexto={darkMode ? 'white' : 'black'}
                    />
                    {loading ?
                        <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                        </Skeleton>
                        :
                        <Grid container spacing={2} style={{ margin: 40 }}>

                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={12}
                                style={{ marginTop: 1 }}
                            >

                                <Grid item xs={3}
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="area-selector-label" style={{ color: darkMode ? 'white' : undefined }}>Tipo de Saida de Estoque</InputLabel>
                                            <Select
                                                labelId="area-selector-label"
                                                id="area-selector"
                                                value={tipo}
                                                onChange={handleChangeTipo}
                                                label="Tipo de Saida de Estoque"
                                                style={{ color: darkMode ? 'white' : undefined, borderBottom: darkMode ? '1px solid white' : undefined }}
                                            >
                                                <MenuItem value={0}>Não Definido</MenuItem>
                                                <MenuItem value={10}>Ordem de Serviço</MenuItem>
                                                <MenuItem value={20}>Consumo Interno</MenuItem>
                                                <MenuItem value={30}>Perda - Avaria</MenuItem>
                                                <MenuItem value={40}>Transferência entre Estoque</MenuItem>
                                                <MenuItem value={50}>Empréstimo / Comodato</MenuItem>
                                                <MenuItem value={60}>Empréstimo / Comodato</MenuItem>

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={2}
                                    item xs={12}
                                    style={{ marginTop: 15 }}
                                >
                                    <Grid item xs={6}>
                                        <Autocomplete
                                            id="select-cliente-destinatario"
                                            options={clienteDestinatarioSearchResult}
                                            getOptionLabel={(option) => getDescricaoCliente(option)}
                                            value={clienteDestinatario}
                                            onChange={(event, newValue) => {
                                                setClienteDestinatario(newValue);
                                            }}
                                            onInputChange={(event, newInputValue) => {
                                                setClienteDestinatarioInputValue(newInputValue);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Cliente Destinatário"
                                                    variant="standard"
                                                    placeholder="Digite 3 ou mais caracteres..."
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Autocomplete
                                            id="select-contato-destinatario"
                                            options={contatoDestinatarioSearchResult}
                                            getOptionLabel={(option) => option ? `ID: ${option.id_contato} - ${option.nome_contato} - ${option.celular_contato}` : ''}
                                            value={contatoDestinatario}
                                            onChange={(event, newValue) => {
                                                setContatoDestinatario(newValue);
                                            }}
                                            onInputChange={(event, newInputValue) => {
                                                setContatoDestinatarioInputValue(newInputValue);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Contato Destinatário"
                                                    variant="standard"
                                                    placeholder="Digite 3 ou mais caracteres..."
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    align="center"
                                    item xs={12}
                                >

                                    <Autocomplete
                                        id="select-ordem-servico"
                                        options={ordensServicos || []}
                                        disableCloseOnSelect
                                        getOptionLabel={(ordem) => returnDescricaoOrdem(ordem).replace(/<br \/>/g, '\n')}
                                        value={ordemServicoSelecionada}
                                        onChange={handleOrdemServico}
                                        filterOptions={(options, { inputValue }) => {
                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                            return options.filter((ordem) => {
                                                const cotacaoText = returnDescricaoOrdem(ordem).toLowerCase();
                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                            });
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label=" Ordem de Serviço " multiline minRows={3} />
                                        )}
                                        renderOption={(option) => (
                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoOrdem(option) }} />
                                        )}

                                    />
                                </Grid>
                            </Grid>


                            <Grid
                                style={{ paddingTop: 5 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >
                                {!ordemServicoSelecionada &&

                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        align="center"
                                        item xs={6}
                                        style={{ marginTop: 5 }}
                                    >
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}
                                        >

                                            <Autocomplete
                                                id="select-ordem"
                                                options={ordensCompras}
                                                freeSolo
                                                disableCloseOnSelect
                                                getOptionLabel={(ordem) => returnDescricaoOrdemCompra(ordem).replace(/<br \/>/g, '\n')}
                                                value={ordemCompraSelecionada}
                                                onChange={(e, v) => handleSetOrdemCompra(v)}
                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((cotacao) => {
                                                        const cotacaoText = returnDescricaoOrdemCompra(cotacao).toLowerCase();
                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label=" Ordem de Compra " multiline minRows={3} />
                                                )}
                                                renderOption={(option) => (
                                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoOrdemCompra(option) }} />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                }






                            </Grid>

                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={12}
                                style={{ marginTop: 3 }}
                            >
                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    align="center"
                                    item xs={12}
                                >

                                    <Autocomplete
                                        id="select-solicitantes"
                                        options={solicitantes}
                                        disableCloseOnSelect
                                        multiple
                                        getOptionLabel={(solicitante) => returnDescricaoSolicitante(solicitante).replace(/<br \/>/g, '\n')}
                                        value={solicitantesSelecionados}
                                        onChange={handleAdicionarSolicitante}
                                        filterOptions={(options, { inputValue }) => {
                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                            return options.filter((solicitante) => {
                                                const cotacaoText = returnDescricaoSolicitante(solicitante).toLowerCase();
                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                            });
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label=" Solicitantes " multiline minRows={2} />
                                        )}
                                        renderOption={(option) => (
                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoSolicitante(option) }} />
                                        )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((solicitante, index) => (
                                                <Chip
                                                    label={returnDescricaoSolicitante(solicitante)}
                                                    {...getTagProps({ index })}
                                                    onDelete={(event) => handleRemoverSolicitante(event, solicitante)}
                                                />
                                            ))
                                        }
                                    />
                                </Grid>
                            </Grid>


                            <Grid item xs={12}>
                                <TextField
                                    variant="standard"
                                    name="descricao"
                                    label="Descrição"
                                    id="descricao"
                                    value={descricao}
                                    onChange={(e) => setDescricao(e.target.value)}
                                    fullWidth
                                    multiline
                                    minRows={3}
                                />
                            </Grid>


                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center"
                                item xs={10}
                            >
                                <Button style={{ margin: 5 }}
                                    variant="contained"
                                    color="primary"
                                    onClick={salvar}
                                > Salvar  </Button>
                            </Grid>

                        </Grid>


                    }


                </div>
            </MuiThemeProvider>
        </CoreThemeProvider>
    );
}


